
const offset = (el: any) => {
  const rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return {
    top: rect.top + scrollTop,
    left: rect.left + scrollLeft
  };
};

export const getTimeInSecs = (value: any, type: number) => {
  try {
    if(!value) return 0;
    value = parseInt(value);
    if (type === 2) {
      return value * 60;
    } else if (type === 3) {
      return value * 60 * 60;
    } else if (type === 1) {
      return value;
    }
  } catch (e) {
    return -1;
  }
};

export const getTime = (time: any, isEdit?: boolean) => {
  try {
    if(!time) return ''
    let _time = time
    if (time >= 60 && time < 3600) {
      time = (time%60) != 0 ? time : time/60
      time = isEdit ? parseInt(time) : time
    } 
    else if (time >= 3600) {
      time = (time%3600) != 0 ? time : time/3600;
      time = isEdit ? parseInt(time) : time
    }
    if(Number.isInteger(time)) return time; 
    else return _time
  } catch (e) {
    return "";
  }
};

export const getTimeUnit = (time: any, isShowInNumber?: boolean) => {
  try {
    if(!time) throw 'err'
    if (time >= 60 && time < 3600) {
      if((time%60) != 0) return isShowInNumber ? 1 : "sec";
      return isShowInNumber ? 2 : "min";
    }
    else if (time >= 3600) {
      if((time%3600) != 0) return isShowInNumber ? 1 : "sec";
      return isShowInNumber ? 3 : "hour";
    } else {
      return isShowInNumber ? 1 : "sec";
    }
  } catch (e) {
    return (isShowInNumber && 2) || '';
  }
};

export const convertTime = (time: any, state: string, currState: string) => {
  try {
    if(time === '' || time === null || time == undefined) throw 'err'
    if(state === 'min') {
      switch(currState) {
        case 'hour':
          return time/60
        case 'sec':
        return time*60
        default: return time
      }
    } else if(state === 'hour') {
      switch(currState) {
        case 'min':
          return time*60
        case 'sec':
        return time*3600
        default: return time
      }
    } else if(state === 'sec') {
      switch(currState) {
        case 'min':
          return time/60
        case 'hour':
        return time/3600
        default: return time
      }
    }
    // if(prevState === 1 && currState === 2) return time/60         // min -> hour
    // if(prevState === 3 && currState === 2) return time/3600       // sec -> hour
    // if(currState === 1) return time*60                            // hour -> min
    // if(currState === 3) return time*3600                          // hour -> sec
  } catch(e) {
    return time
  }

}

export const getVariationName = (history: any) => {
  try {
    return (history.location.search.search('vKey') != -1
    && history.location.search.split('?')[1].split('=')[1]) || ''
  } catch(e) {
    return ''
  }
}

export const parseTime = (timeInSecs: number) => {
  try {
    const time = new Date(timeInSecs * 1000).toISOString().substr(11, 8).split(':');
    const hh: any = time[0];
    const mm: any = time[1];
    let ss: any = time[2];
    let str = "";
    if (hh != 0) str += `${hh} hr `;
    if (mm !=0) str += `${mm} min `;
    if (ss) {
      if(ss == 0) ss = parseInt(ss)
      if (ss > 0 && ss < 10){
        ss = ss.replace(/^0+/, '');
      }
      str += `${ss} sec`;
    } 
    return str;
  } catch (e) {
    return "";
  }
}

export default offset;
